<template>
<div>
    <v-poolscrollmain v-if="chainId == 534352"></v-poolscrollmain>
    <v-poolzksyncmain v-if="chainId == 324"></v-poolzksyncmain>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 534352
            if(this.$route.query.network == 'scroll' && this.chainId == 534352){
                return
            }
            if(this.$route.query.network == 'zksync' && this.chainId == 324){
                return
            }
            if(this.$route.query.network == 'scroll' && this.chainId != 534352){
                localStorage.setItem('chainId',534352)
                
                window.location.reload();
            } else if (this.$route.query.network == 'zksync' && this.chainId != 324){
                localStorage.setItem('chainId',324)
                console.log(this.chainId)
                
                window.location.reload();
            } else{
                localStorage.setItem('chainId',534352)
                
                this.$router.push({push:'/pool', query:{network:'scroll'}})
            }
            
        },
    }
</script> 